import { useEffect } from "react";
import { useLayoutContext } from "src/contexts/LayoutContext";
import LitigatorSearch from "./LitigatorSearch";

const Index = () => {
  const { setHeading, setTagline } = useLayoutContext();
  useEffect(() => {
    if (setHeading && setTagline) {
      setHeading("Litigator Research");
      setTagline("Use this tool to research litigants");
    }
  }, [setHeading, setTagline]);

  return <LitigatorSearch />;
};

export default Index;
